import { h } from 'preact';
import register from 'preact-custom-element';
import SelfServiceForm from './components/form/self-service';
import { SelfServiceFormProps } from './components/form/self-service/types';
import './scss/shared.scss';
import './scss/self-service.scss';

const SiteConfig: Record<string, SelfServiceFormProps> = {
    branston: {
        origin: 'Branston Website',
        products: {
            'Pickle': {
                '01t8d000000AeunAAC': 'Original Pickle (360g)',
                '01t8d000000AeupAAC': 'Original Pickle (520g)',
                '01t8d000000AeuqAAC': 'Original Pickle (720g)',
                '01t8d000000AeusAAC': 'Small Chunk Pickle (360g)',
                '01t8d000000AeuuAAC': 'Small Chunk Pickle (520g)',
                '01t8d000000AeuvAAC': 'Small Chunk Pickle (720g)',
                '01t8d000000AeuwAAC': 'Smooth Pickle',
            },
            'Squeezy Pickle': {
                '01t8d000000AeuxAAC': 'Small Chunk Squeezy Pickle',
                '01t8d000000AeuyAAC': 'Smooth Squeezy Pickle',
            },
            'Piccalilli': {
                '01t8d000000Aev6AAC': 'Piccalilli',
                '01t8d000000Aev7AAC': 'Small Chunk Piccalilli',
                '01tPz00000H9fRxIAJ': 'Chilli Piccalilli',
            },
            'Sauce': {
                '01t8d000000Aev5AAC': 'Rich & Fruity sauce',
            },
        },
        classNames: {
            heading: 'text-xl  sm:text-2xl  md:text-3xl  leading-none',
            button: {
                submit: 'button  button--wide  heading-text  text-md  weight-black  uppercase  theme--secondary',
                findAddress: 'button  heading-text  text-md  weight-black  uppercase  theme--secondary',
                close: 'button  button--wide  heading-text  text-md  weight-black  uppercase  theme--secondary',
            },
        },
        links: {
            faqs: '/faqs/',
            privacy: '/fair-processing-notice/',
            recipes: '/recipes/',
            recycling: '/faqs/#recycling',
            range: '/range/',
        },
        emailAddresses: {
            trade: 'trade.enquiries@mizkan.co.uk',
            hr: 'HR@mizkan.co.uk',
        },
        images: {
            code: '/wp-content/themes/branston-2020/dist/images/contact/branston-lid.png',
        },
    },
    sarsons: {
        origin: 'Sarsons Website',
        products: {
            'Malt Vinegar': {
                '01t8d000000AevNAAS': 'Malt Vinegar (250ml)',
                '01t8d000000AevOAAS': 'Malt Vinegar (284ml)',
                '01t8d000000AevPAAS': 'Malt Vinegar (400ml)',
                '01t8d000000AevQAAS': 'Malt Vinegar (568ml)',
            },
            'Distilled Malt Vinegar': {
                '01t8d000000AevSAAS': 'Distilled Malt Vinegar (250ml)',
                '01t8d000000AevTAAS': 'Distilled Malt Vinegar (284ml)',
                '01t8d000000AevUAAS': 'Distilled Malt Vinegar (568ml)',
            },
            'Pickling Vinegar': {
                '01t8d000000AevRAAS': 'Classic Malt Pickling Vinegar',
                '01t8d000000AevVAAS': 'Distilled Malt Pickling Vinegar',
            },
            'Pickled Vegetables': {
                '01tPz000003x4CMIAY': 'Sweet Onions',
                '01tPz000003x3HuIAI': 'Silverskin Onions',
                '01tPz000003x5mjIAA': 'Mixed Pickle',
                '01tPz000003x5unIAA': 'Red Cabbage',
                '01tPz000003x5rZIAQ': 'Hot & Spicy Onions',
            },
            'Sauce': {
                '01t8d000000AevWAAS': 'Worcester Sauce',
                '01t8d000000AevXAAS': 'Gravy Browning Sauce',
            },
        },
        classNames: {
            heading: 'font-veneer  caps',
            button: {
                submit: 'button  button--light  font-veneer  caps',
                findAddress: 'button  button--light  font-veneer  caps',
                close: 'button  button--light  font-veneer  caps',
            },
        },
        links: {
            faqs: '/faqs/',
            privacy: '/privacy/',
            recipes: '/recipes/',
            recycling: '/how-to/#recycling',
            range: '/products/',
        },
        emailAddresses: {
            trade: 'trade.enquiries@mizkan.co.uk',
            hr: 'HR@mizkan.co.uk',
        },
        images: {
            code: '/wp-content/themes/sarsons/images/sarsons-lid.png',
        },
    },
    haywards: {
        origin: 'Haywards Website',
        products: {
            '01t8d000000AevEAAS': 'Medium & Tangy Mixed Pickle',
            '01t8d000000Aev9AAC': 'Medium & Tangy Silverskin Onions',
            '01t8d000000AevHAAS': 'Sweet & Mild Red Cabbage',
            '01t8d000000Aev8AAC': 'Sweet & Mild Silverskin Onions',
            // '01t8d000000AevCAAS': 'Hot & Spicy Onions', // missing from latest data file
        },
        classNames: {
            heading: 'form__heading',
            button: {
                submit: 'button  button--large',
                findAddress: 'button  button--small',
                close: 'button  button--medium',
            },
        },
        links: {
            faqs: '/faqs/',
            privacy: '/fair-processing-notice/',
            recipes: '/recipes/',
            recycling: '/faqs/#recycling',
            range: '/range/',
        },
        emailAddresses: {
            trade: 'trade.enquiries@mizkan.co.uk',
            hr: 'HR@mizkan.co.uk',
        },
        images: {
            code: '/wp-content/themes/haywards/images/haywards-lid.png',
        },
    },
};

function Form({ site }: FormProps) {
    if (SiteConfig[site] === undefined) {
        throw new Error(`Invalid site config identifier "${site}"`);
    }

    return h(SelfServiceForm, SiteConfig[site]);
}

type FormProps = {
    site: string,
};

register(Form, 'mizkan-self-service-form', ['site']);
